import demo from  './refinance_demo.json';
import oto from  './refinance_oto.json';
const finaljson={demo,oto}
export default finaljson;
